module.exports = "v6.8.54";


//////////////////
// WEBPACK FOOTER
// ./node_modules/val-loader/dist/cjs.js!./src/builderVersion.js
// module id = 228
// module chunks = 0 1